import { JasperService } from './../shared/jasper.service';
import { Component, OnInit, Input } from '@angular/core';
import { ControlStatusService } from '../shared/control-status.service';
import { Util } from "../shared/Util";
import * as XLSX from 'xlsx';
import { NgFor, NgClass, NgIf } from '@angular/common';

type AOA = any[][];
declare let jsPDF;
declare var bootbox: any
declare let $: any

@Component({
    selector: 'app-relatorios-dashboard-card',
    templateUrl: './relatorios-dashboard-card.component.html',
    styleUrls: ['./relatorios-dashboard-card.component.css'],
    standalone: true,
    imports: [NgFor, NgClass, NgIf]
})
export class RelatoriosDashboardCardComponent implements OnInit {

  @Input() card;
  relatorios: any = [];
  ordemPlanejada: any = [];
  ordemRelatorio: any[][]
  arrayRelatorios: any = [];
  urlJasper: string;

  constructor(private util: Util,
    public controlStatus: ControlStatusService,
    public jasperService: JasperService) { }

  data: AOA = [['Roteiro', 'Cliente', 'Razão Social', 'Lat/Long', 'Lat/Long Entrega', 'Distância Metros', 'Endereço'], this.relatorios];
  wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
  fileName: string = 'SheetJS.xlsx';

  ngOnInit() {
    
    this.arrayRelatorios = [
      { id: 1, nome: 'Roteiro de entregas no cliente', pastaJasper: 'ROTENTR' },
      { id: 2, nome: 'Ocorrências', pastaJasper: 'ROTOC' },
      { id: 3, nome: 'Roteiros por motorista', pastaJasper: 'ROTPM' },
      { id: 4, nome: 'Ocorrências por motorista', pastaJasper: 'ROTOCP' },
      { id: 5, nome: 'Roteiros do dia', pastaJasper: 'ROTDIA' },
      { id: 6, nome: 'Tempo médio de entrega por cliente', pastaJasper: 'ROTTC' },
      { id: 7, nome: 'Intervalo de entrega por cliente', pastaJasper: 'ROTINTC' },
      { id: 8, nome: 'Jornada de trabalho do motorista', pastaJasper: 'ROTTABM' },
      { id: 9, nome: 'Forma de pagamento', pastaJasper: 'ROTFP' },
      { id: 10, nome: 'Custo do roteiro por entrega', pastaJasper: 'ROTCUF' },
      { id: 11, nome: 'Ocorrências de Custo Extra por Roteiro', pastaJasper: 'OCEXTROT' },
      { id: 12, nome: 'Avaliação de entregas por motorista', pastaJasper: 'ROTAVAMOT' },
    ]

    let dataInicial = new Date();
    let mesInicio = dataInicial.getMonth() + 1;
    let anoInicio = dataInicial.getFullYear();
    this.controlStatus.dataInicio = `01/${this.util.formataDataMes(mesInicio)}/${anoInicio}`;
    this.controlStatus.dataFim = `${this.util.formataDataDia(dataInicial.getDate())}/${this.util.formataDataMes(dataInicial.getMonth() + 1)}/${dataInicial.getFullYear()}`

  }

  transform(val, args) {
    if (args === undefined) {
      return val;
    }

    if (val.length > args) {
      return val.substring(0, args) + '...';
    } else {
      return val;
    }
  }

  async openJasperReport(tipoRelatorio, formatoRelatorio?:string) {
    this.controlStatus.carregandoRelatoriosJasper = true;
    this.controlStatus.avisoRelatorio = 'Carregando Informações...'

    if(formatoRelatorio){
      this.controlStatus.controleModeloReport = formatoRelatorio
    }

    ///DEFINE OS TIPOS DE RELATORIOS E ABRE O MODAL
    this.controlStatus.tipoRelatorio = tipoRelatorio
    document.getElementById('defineTipoRel').click()
    $("#modalRelJasper").modal('show');
  }
}
